import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  Validators,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { UserSchema } from '../../models';
import { AuthService } from '../../services';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthInnerRouterParams } from '../auth-form/auth-form.component';
import { AuthStatusObject, iranPhoneValidator } from 'src/app/shared';
import { SubSink } from 'subsink';

@Component({
  selector: 'auth-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnChanges {
  @Input('landing-auth-sidenav') authSidenav!: MatSidenav;
  @Output('on-error') onError: EventEmitter<UserSchema> = new EventEmitter();
  @Input('inner-router') innerRouter!: BehaviorSubject<AuthInnerRouterParams>;
  @Input() otp = false;
  @Output('auth-event') onAuth: EventEmitter<AuthStatusObject> =
    new EventEmitter();
  @ViewChild('phoneForOtp') phoneForOtp: ElementRef;
  @ViewChild('codeForOtp') codeForOtp: ElementRef;

  @Output() loadingStart = new EventEmitter();
  @Output() stopLoading = new EventEmitter();
  public subsink = new SubSink();
  userProfile: UserSchema;
  loginForm: FormGroup;
  loginOtp: FormGroup;
  forgetPasswordForm: FormGroup;
  otpStep = 1;
  loading = false;
  resetPasswordToken = '';
  constructor(
    private authService: AuthService,
    private snackbar: MatSnackBar,
    private fb: FormBuilder
  ) {
    this.loginForm = fb.group({
      phone: [
        '',
        [
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.required,
          iranPhoneValidator,
        ],
      ],
      password: [
        '',
        [
          Validators.minLength(8),
          Validators.maxLength(64),
          Validators.required,
        ],
      ],
    });
    this.loginOtp = fb.group({
      phone: [
        '',
        [
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.required,
          iranPhoneValidator,
        ],
      ],
      code: [
        '',
        [Validators.minLength(6), Validators.maxLength(6), Validators.required],
      ],
    });
    this.forgetPasswordForm = fb.group({
      newPassword: [
        '',
        [
          Validators.minLength(8),
          Validators.maxLength(64),
          Validators.required,
        ],
      ],
      // renewPassword: [
      //   '',
      //   [
      //     Validators.minLength(8),
      //     Validators.maxLength(64),
      //     Validators.required,
      //   ],
      // ],
    });
  }

  async ngOnInit() {
    // const userProfile = await firstValueFrom(this.authService.getUserProfile());
    this.subsink.sink = this.authService.userProfile.subscribe((profile) => {
      this.userProfile = profile;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['otp']?.currentValue === true) {
      this.otpStep = 1;
      this.loginOtp.controls['code'].setValidators([]);
      this.loginOtp.controls['code'].updateValueAndValidity();
      this.loginOtp.controls['code'].disable();
      this.loginOtp.controls['phone'].enable();
      this.loginOtp.updateValueAndValidity();
      this.forgetPass = false;
      setTimeout(() => {
        this.phoneForOtp.nativeElement.focus();
      }, 10);
    } else if (changes['otp']?.currentValue === false) {
      this.forgetPass = false;
    }
  }

  public get phone(): AbstractControl {
    return this.loginForm.get('phone') as AbstractControl;
  }

  public get password(): AbstractControl {
    return this.loginForm.get('password') as AbstractControl;
  }

  public get newPassword(): AbstractControl {
    return this.forgetPasswordForm.get('newPassword') as AbstractControl;
  }

  loginSubmit() {
    const loginData: any = this.loginForm.value;
    this.loadingStart.emit();

    this.subsink.sink = this.authService.classicLogin(loginData).subscribe(
      (statusObject: AuthStatusObject) => {
        if ('data' in statusObject && statusObject.data && statusObject.isOk) {
          this.onAuth.emit(statusObject);
        }
      },
      (error: unknown) => {
        this.snackbar.open('شماره یا رمز عبور اشتباه است', 'باشه', {
          duration: 1000,
        });
        this.stopLoading.emit();
        this.onError.emit(error as any);
      }
    );
  }
  codeTimer = 180;
  codeTimeout: any;
  loginWithOtp(resend = false) {
    if (this.forgetPass) {
      if (this.forgetPasswordStep === 2) {
        this.setNewPassword();
        return;
      } else if (this.otpStep === 1 || resend) {
        this.sendOtpForgetPasswordOtp();
        return;
      } else if (this.otpStep === 2) {
        this.verifyOtpForgetPassword();
        return;
      }
    } else {
      if (this.otpStep === 1 || resend) {
        this.codeTimer = 180;
        this.loading = true;
        this.authService
          .requestLoginCode(this.loginOtp.controls['phone'].value)
          .subscribe({
            next: (res) => {
              this.loading = false;
              if (res?.data?.statusCode === 200) {
                this.otpStep = 2;
                this.loginOtp.controls['code'].setValidators([
                  Validators.minLength(6),
                  Validators.maxLength(6),
                  Validators.required,
                ]);
                this.loginOtp.controls['code'].enable();
                this.loginOtp.controls['phone'].disable();
                this.loginOtp.updateValueAndValidity();
                this.snackbar.open(
                  'کد ورود یک بار مصرف به شماره همراه شما ارسال شد.',
                  'باشه',
                  {
                    duration: 3000,
                  }
                );
                setTimeout(() => {
                  this.codeForOtp.nativeElement.focus();
                  this.loginOtp.controls['code'].reset();
                }, 10);
                clearInterval(this.codeTimeout);
                this.codeTimeout = setInterval(() => {
                  this.codeTimer = this.codeTimer - 1;
                  if (this.codeTimeout < 0) clearInterval(this.codeTimeout);
                }, 1000);
              }
            },
            error: (error) => {
              this.loading = false;
              if (error?.status === 429) {
                this.snackbar.open(
                  'تعداد درخواست بیش از حد مجاز است. لطفا چند دقیقه بعد مجددا تلاش کنید.',
                  'باشه',
                  {
                    duration: 5000,
                  }
                );
              } else {
                this.snackbar.open(
                  'خطا در ارسال درخواست. لطفا مجددا تلاش کنید.',
                  'باشه',
                  {
                    duration: 5000,
                  }
                );
              }
              this.stopLoading.emit();
              this.onError.emit(error as any);
            },
          })
          .add(() => {
            this.loading = false;
          });
      } else if (this.otpStep === 2) {
        this.loading = true;
        this.authService
          .verifyLoginCode(
            this.loginOtp.controls['phone'].value,
            this.loginOtp.controls['code'].value
          )
          .subscribe({
            next: (res) => {
              this.loading = false;
              if ('data' in res && res.data && res.isOk) {
                this.onAuth.emit(res);
              }
            },
            error: (error) => {
              this.loading = false;
              if (error?.status === 429) {
                this.snackbar.open(
                  'تعداد درخواست بیش از حد مجاز است. لطفا چند دقیقه بعد مجددا تلاش کنید.',
                  'باشه',
                  {
                    duration: 5000,
                  }
                );
              } else if (error?.status === 400) {
                this.snackbar.open('کد وارد شده نامعتبر است.', 'باشه', {
                  duration: 5000,
                });
              } else {
                this.snackbar.open(
                  'خطا در ارسال درخواست. لطفا مجددا تلاش کنید.',
                  'باشه',
                  {
                    duration: 5000,
                  }
                );
              }
              this.stopLoading.emit();
              this.onError.emit(error as any);
            },
          })
          .add(() => {
            this.loading = false;
          });
      }
    }
  }
  forgetPass = false;
  forgetPasswordStep = 1;
  forgetPassword() {
    this.forgetPass = true;
    this.forgetPasswordStep = 1;
    this.otpStep = 1;
    this.otp = true;
    this.loginOtp.controls['code'].setValidators([
      Validators.minLength(6),
      Validators.maxLength(6),
    ]);
    this.loginOtp.controls['code'].disable();
  }
  sendOtpForgetPasswordOtp() {
    this.codeTimer = 180;
    this.loading = true;
    this.authService
      .requestResetPassword(this.loginOtp.controls['phone'].value)
      .subscribe({
        next: (res: any) => {
          if (res?.statusCode == 200) {
            this.otpStep = 2;
            this.loginOtp.controls['code'].setValidators([
              Validators.minLength(6),
              Validators.maxLength(6),
              Validators.required,
            ]);
            this.loginOtp.controls['code'].enable();
            this.loginOtp.controls['phone'].disable();
            this.loginOtp.updateValueAndValidity();
            this.snackbar.open(
              'کد ورود یک بار مصرف به شماره همراه شما ارسال شد.',
              'باشه',
              {
                duration: 3000,
              }
            );
            setTimeout(() => {
              this.codeForOtp.nativeElement.focus();
              this.loginOtp.controls['code'].reset();
            }, 10);
            clearInterval(this.codeTimeout);
            this.codeTimeout = setInterval(() => {
              this.codeTimer = this.codeTimer - 1;
              if (this.codeTimeout < 0) clearInterval(this.codeTimeout);
            }, 1000);
          }
        },
        error: (error) => {
          this.loading = false;
          if (error?.status === 429) {
            this.snackbar.open(
              'تعداد درخواست بیش از حد مجاز است. لطفا چند دقیقه بعد مجددا تلاش کنید.',
              'باشه',
              {
                duration: 5000,
              }
            );
          } else {
            this.snackbar.open(
              'خطا در ارسال درخواست. لطفا مجددا تلاش کنید.',
              'باشه',
              {
                duration: 5000,
              }
            );
          }
          this.stopLoading.emit();
          this.onError.emit(error as any);
        },
      })
      .add(() => {
        this.loading = false;
      });
  }
  verifyOtpForgetPassword() {
    this.loading = true;
    this.authService
      .verifyResetPasswordOtp(
        this.loginOtp.controls['phone'].value,
        this.loginOtp.controls['code'].value
      )
      .subscribe({
        next: (res: any) => {
          if (res?.resetPasswordToken) {
            this.forgetPasswordStep = 2;
            this.loading = false;
            this.resetPasswordToken = res.resetPasswordToken;
            this.snackbar.open('کد یک بار مصرف تایید شد.', 'باشه', {
              duration: 5000,
            });
          }
        },
        error: (error) => {
          this.snackbar.open(
            error?.error?.message || 'کد ارسال شده صحیح نمی‌باشد.',
            'باشه',
            {
              duration: 1000,
            }
          );
          console.log(error);
          this.loading = false;
        },
      });
  }
  setNewPassword() {
    this.loading = true;
    this.authService
      .setNewPassword(
        this.forgetPasswordForm.controls['newPassword'].value,
        this.resetPasswordToken
      )
      .subscribe({
        next: (res: any) => {
          if (res?.statusCode == 200) {
            this.forgetPasswordStep = 1;
            this.forgetPass = false;
            this.otp = false;
            this.loading = false;
            this.snackbar.open('رمز عبور با موفقیت ذخیره شد.', 'باشه', {
              duration: 5000,
            });
          }
        },
        error: (error) => {
          this.snackbar.open(
            error?.error?.message || 'خطا در ثبت رمز عبور.',
            'باشه',
            {
              duration: 3000,
            }
          );
          this.loading = false;
        },
      });
  }
  resendCode() {
    if (this.codeTimer > 0) return;
    this.loginWithOtp(true);
  }
  toggleRegister() {
    this.innerRouter.next('register');
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
    this.stopLoading.emit();
  }
}
